/* RESPONSIBLE TEAM: team-actions */

import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';

export default class AutomationFinAIAgentProceduresRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;

  get titleToken() {
    return this.intl.t('ai-agent.new-submenu.procedures');
  }
}
